import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isAfter } from 'date-fns';
import { toNum } from '@shared/helpers/math.helper';
import { toJsDateMsOrNull } from '@shared/helpers/date.helper';
import { DATE_NOT_ALLOWED, NOT_VALID } from '@shared/constants/shared.constants';
import { toBoolean } from '@shared/helpers/utils.helper';

const DATE_2079 = new Date('2079-06-06');

const CONFERMA_XBRL_STATUS = 'Attenzione: valore non confermato';
const MSG_TOT_ATTIVO_NON_CONFERMATO = 'Valore del totale attivo presente nel bilancio non confermato';
const MSG_PATR_NETTO_NON_CONFERMATO = 'Valore del patrimonio netto presente nel bilancio non confermato';

const validateDataChiusura = (value: string, fieldKey: string): ValidationErrors | null => {
    if (!value) return null;
    const ms = toJsDateMsOrNull(value);
    if (ms === null) return { [fieldKey]: { status: NOT_VALID } };
    if (isAfter(new Date(ms), DATE_2079)) return { [fieldKey]: { status: DATE_NOT_ALLOWED } };
    return null;
};

// Validatore sincrono per le checkbox di conferma valore XBRL: errore se il valore del
// proprio control non è confermato. Sincrono per evitare lo stato PENDING (flick) sulle checkbox.
const buildConfermaXbrlValidator = (errorKey: string, message: string): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null =>
        toBoolean(control.value) ? null : { [errorKey]: { status: CONFERMA_XBRL_STATUS, message } };
};

@Injectable()
export class DatiBilancioBisFieldValidators {
    my_checkTotAttivoAnnoXBRL = buildConfermaXbrlValidator('my_ckTotAttivoAnnoXBRL', MSG_TOT_ATTIVO_NON_CONFERMATO);

    my_checkTotAttivoAnno1XBRL = buildConfermaXbrlValidator('my_ckTotAttivoAnno1XBRL', MSG_TOT_ATTIVO_NON_CONFERMATO);

    my_checkPatrNettoAnnoXBRL = buildConfermaXbrlValidator('my_ckPatrNettoAnnoXBRL', MSG_PATR_NETTO_NON_CONFERMATO);

    my_checkPatrNettoAnno1XBRL = buildConfermaXbrlValidator('my_ckPatrNettoAnno1XBRL', MSG_PATR_NETTO_NON_CONFERMATO);

    my_DataChiusura2: ValidatorFn = (control) => validateDataChiusura(control.value, 'my_DataChiusura2');

    my_DataChiusura1: ValidatorFn = (control) => validateDataChiusura(control.value, 'my_DataChiusura1');

    my_StPaAtTOT2PatrimonioNullo: ValidatorFn = (control) =>
        toNum(control.value) === 0 ? { my_StPaAtTOT2PatrimonioNullo: { status: 'Il totale dello Stato Patrimoniale Attivo del secondo bilancio è nullo' } } : null;
}
